import React, { FC, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { observer } from 'mobx-react-lite';
import { AdminSettingsService, useViewModel } from '@utils';
import { ProfilePageDesktop } from './ProfilePageDesktop';
import { ProfilePageMobile } from './ProfilePageMobile';
import { ProfileViewModel } from './ProfileViewModel';

export const ProfilePage: FC = observer(() => {

  const profileViewModel = useViewModel(ProfileViewModel);
  const adminSettingsService = useViewModel(AdminSettingsService);

  useEffect(() => {
    profileViewModel.updateSettings();
    adminSettingsService.init();
    profileViewModel.getAlertState();
    sessionStorage.removeItem('filter');
  }, []);

  useEffect(() => {
    profileViewModel.setTimeZone();
  }, [profileViewModel.timeZoneId]);

  return (
    isMobile
      ? <ProfilePageMobile />
      : <ProfilePageDesktop />
  );
});
